import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://ulblxecuiuouwrudtmnt.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVsYmx4ZWN1aXVvdXdydWR0bW50Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU4OTk3NjksImV4cCI6MjA5MTQ3NTc2OX0.uEFImWWQvrPiBj7WeEHx8mdqUHhLJNywzV9Oji4uEpw'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

export default supabase;